import * as React from 'react';
import { cloneDeep, debounce, values } from 'lodash';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { message, Popover, Popconfirm, Switch, Space } from 'antd';
import {
  SourceType
} from '@config/index';
import {
  NiModal,
  TrainingPhraseComp,
  PromptListComp,
  NiForm,
  NiFormItem,
  discardModal,
  NiBooleanRadio,
  ReferenceTextArea,
  NiRadio,
  InputParameterComp,
  NiSelect,
  NiTable,
  HelperPopover,
  AddButton
} from '@component/index';
import {
  IntentInfo,
  Attribute,
  DataQuery,
  ValueRecommendationSourceType,
  ValueSuggestionData,
  IntentAssignment,
  FrameType,
  DiffStates,
  DefaultValueSuggestionChannels,
  ActionChannel,
  TrainingPhraseConfig,
  TrainingPhraseOwnerType,
  TrainingPhraseType,
  PromptInfo,
  PromptOwnerType,
  PromptType,
  Reference,
  ParameterType,
  InputParameter
} from '@interface/index';
import {
  UseResponses
} from './components/modal-comps';
import { localizedString } from '@locale/index';
import { FormattedMessage } from 'react-intl';
import {
  isEqual,
  getAgentId,
  isStructAgent,
  ParameterMapStore,
  dataQueryToParameter,
  getFullName
} from '@lib/index';

import '@style/value-suggestion/modal.less';
import { NewPromptList, PromptListHandle } from '@component/prompt/new-prompt-list';
import CodeTextArea from '@component/code-textarea/code-textarea';

export interface ValueSuggestionModalProps {
  disabled?: boolean;
  frame: any;
  frameType: FrameType;
  forSlot?: Attribute;
  visible: boolean;
  data: ValueSuggestionData;
  dataQueries: DataQuery[];
  selectedParameters: Attribute[];
  availableIntents: IntentInfo[];
  availableChannels: string[];
  didOverwrite?: () => void;
  onChange: (next: ValueSuggestionData) => void;
  onClose: () => void;
}
export interface ValueSuggestionModalState {
  data: ValueSuggestionData;
}
export class ValueSuggestionModal extends React.Component<
  ValueSuggestionModalProps,
  ValueSuggestionModalState
> {
  public state: ValueSuggestionModalState = {
    data: {
      id: '',
      ownerId: '',
      ownerType: '',
      vrSourceType: ValueRecommendationSourceType.codeExpression,
      sourceType: SourceType.CODE_EXPRESSION,
      source: '',
      variable: [],
      parameters: [],
      channels: DefaultValueSuggestionChannels as any,
      state: DiffStates.NORMAL,
      soft: false,
      singlePrompts: [],
      zeroPrompts: [],
      singleAffirmatives: [],
      singleNegatives: []
    }
  };

  constructor(props: ValueSuggestionModalProps) {
    super(props);

    this.state = {
      data: cloneDeep(props.data)
    };
  }

  singlePromptRef = React.createRef<PromptListHandle>();
  zeroPromptRef = React.createRef<PromptListHandle>();

  componentDidMount() {
    this.onInit();
  }
  componentDidUpdate(prevProps: any) {
    if (!isEqual(this.props, prevProps)) {
      this.onInit();
    }
  }

  render() {
    const props = this.props;
    const { disabled, selectedParameters, forSlot, availableIntents, frame } = props;
    const { data } = this.state;

    const sourceIntent = data.sourceIntent && data.sourceIntent.intent &&
      availableIntents.find((item: IntentInfo) =>
        data.sourceIntent && data.sourceIntent.intent && item.id === data.sourceIntent.intent.id);

    const sourceIntentId = sourceIntent && sourceIntent.id;

    const formItems: NiFormItem[] = [
      {
        key: 'vr_source_type',
        label: 'Source',
        // labelExtra: <NiRadio
        //   disabled={disabled  || !!data.originKey}
        //   style={{
        //     marginTop: 4
        //   }}
        //   value={data.vrSourceType}
        //   onChange={(e: any) => {
        //     const next = cloneDeep(data);
        //     next.vrSourceType = e.target.value;

        //     if (next.vrSourceType === ValueRecommendationSourceType.intent && !next.sourceIntent) {
        //       next.sourceIntent = {
        //         type: 'intent_start_action',
        //         intent: undefined as any,
        //         assignments: []
        //       };
        //     }

        //     this.handleUpdate(next);
        //   }}
        //   keyValue={[
        //     { key: ValueRecommendationSourceType.codeExpression, value: localizedString('vr_source_type_code_expression') },
        //     { key: ValueRecommendationSourceType.intent, value: localizedString('vr_source_type_intent') }
        //   ]}
        // />,
        content: data.vrSourceType === ValueRecommendationSourceType.codeExpression ?
          <CodeTextArea
            inModal
            dataId="source"
            disabled={disabled}
            language="kotlin"
            data={data.source}
            update={(nextSource: string) => {
              const next = cloneDeep(data);
              next.source = nextSource;
              this.handleUpdate(next);
            }}
            completionContext={
              {
                rawCodeType: frame
              }
            }
          />
          // <ReferenceTextArea
          //   initParameters={selectedParameters}
          //   parameterMap={ParameterMapStore.all()}
          //   allowNewLine={true}
          //   rawCodeMode={true}
          //   rawCodeType={frame}
          //   disabled={disabled || !!data.originKey}
          //   placeholder={localizedString('condition_add')}
          //   className="reset"
          //   data={data.source}
          //   update={(nextSource: string) => {
          //     const next = cloneDeep(data);
          //     next.source = nextSource;
          //     this.handleUpdate(next);
          //   }}
          //   comment={data.sourceComment}
          //   onCommentChange={(nextComment: string) => {
          //     const next = cloneDeep(data);
          //     next.sourceComment = nextComment;
          //     this.handleUpdate(next);
          //   }}
          // />
          : <NiForm
            direction="vertical"
            items={[{
              key: 'intent',
              label: localizedString('response_type_intent_action'),
              content: <NiSelect
                style={{ width: '100%' }}
                disabled={disabled}
                placeholder={`Select Intent`}
                value={sourceIntentId && sourceIntentId.length && sourceIntentId || undefined}
                onChange={async (value: string) => {

                  const next = cloneDeep(data);

                  const selected: any = availableIntents.find((item: IntentInfo) => item.id === value);
                  if (selected && next.sourceIntent) {

                    next.sourceIntent.intent = {
                      id: selected.id,
                      name: selected.name,
                      type: ParameterType.INTENT
                    };
                    this.handleUpdate(next);
                  }
                }}
              >
                {
                  availableIntents.map((intent: IntentInfo) =>
                    <NiSelect.Option key={intent.id} value={intent.id || ''}>
                      {getFullName(intent)}
                    </NiSelect.Option>)
                }
              </NiSelect>
            },
            {
              key: 'assignments',
              label: localizedString('intent_assignment'),
              content: <NiTable
                pagination={false}
                dataSource={data.sourceIntent && data.sourceIntent.assignments || []}
                rowKey="slot.id"
                columns={[{
                  title: localizedString('attribute_name'),
                  dataIndex: 'slot',
                  width: '30%',
                  render: (_: any, record: IntentAssignment, index: number) => {
                    return <NiSelect
                      style={{ width: '100%' }}
                      disabled={disabled}
                      value={(record.slot && record.slot.length && record.slot[0].id || null) as any}
                      onChange={(value: string) => {
                        const nextAssignments = data.sourceIntent && cloneDeep(data.sourceIntent.assignments) || [];
                        if (sourceIntent) {
                          const slot = sourceIntent.attributes.find((item: Attribute) => item.id === value);

                          if (slot) {
                            const nextAssignment = nextAssignments[index];
                            nextAssignment.slot = [{
                              id: slot.id as string,
                              type: ParameterType.ATTRIBUTE,
                              name: slot.name as string
                            }];
                            nextAssignments[index] = nextAssignment;
                          }
                        }

                        const next = cloneDeep(data);
                        if (next.sourceIntent) {
                          next.sourceIntent.assignments = nextAssignments;
                        }
                        this.handleUpdate(next);
                      }}
                    >
                      {
                        sourceIntent && sourceIntent.attributes.map((item: Attribute) =>
                          <NiSelect.Option key={item.id} value={item.id || ''}>
                            {item.name}
                          </NiSelect.Option>)
                      }
                    </NiSelect>;
                  }
                }, {
                  title: localizedString('code_expression'),
                  dataIndex: 'codeExpression',
                  width: '65%',
                  render: (codeExpression: string, record: IntentAssignment, index: number) => {
                    return <ReferenceTextArea
                      rawCodeMode
                      rawCodeType={frame}
                      disabled={disabled}
                      data={codeExpression}
                      initParameters={[]}
                      parameterMap={{}}
                      update={(next: string) => {
                        const nextAssignments = data.sourceIntent && cloneDeep(data.sourceIntent.assignments) || [];
                        const nextAssignment = nextAssignments[index];
                        nextAssignment.codeExpression = next;
                        nextAssignments[index] = nextAssignment;
                        const nextData = cloneDeep(data);
                        if (nextData.sourceIntent) {
                          nextData.sourceIntent.assignments = nextAssignments;
                        }
                        this.handleUpdate(nextData);
                      }}
                      comment={record.codeComment}
                      onCommentChange={(next: string) => {
                        const nextAssignments = data.sourceIntent && cloneDeep(data.sourceIntent.assignments) || [];
                        const nextAssignment = nextAssignments[index];
                        nextAssignment.codeComment = next;
                        nextAssignments[index] = nextAssignment;
                        const nextData = cloneDeep(data);
                        if (nextData.sourceIntent) {
                          nextData.sourceIntent.assignments = nextAssignments;
                        }
                        this.handleUpdate(nextData);
                      }}
                    />;
                  }
                }, {
                  title: <PlusOutlined
                    onClick={() => {
                      const nextAssignments = data.sourceIntent && cloneDeep(data.sourceIntent.assignments) || [];
                      nextAssignments.push({ slot: [], codeExpression: '' });

                      const nextData = cloneDeep(data);
                      if (nextData.sourceIntent) {
                        nextData.sourceIntent.assignments = nextAssignments;
                      }
                      this.handleUpdate(nextData);
                    }}
                  />,
                  width: '5%',
                  dataIndex: 'operation',
                  render: (_: any, record: IntentAssignment, index: number) => {
                    return <DeleteOutlined
                      onClick={(e: any) => {
                        e.stopPropagation();
                        e.preventDefault();

                        const nextAssignments = data.sourceIntent && cloneDeep(data.sourceIntent.assignments) || [];
                        nextAssignments.splice(index, 1);

                        const nextData = cloneDeep(data);
                        if (nextData.sourceIntent) {
                          nextData.sourceIntent.assignments = nextAssignments;
                        }
                        this.handleUpdate(nextData);
                      }}
                    />;
                  }
                }]}
              />
            }
            ]}
          />
      },
      {
        key: 'response',
        label: localizedString('value_suggestion_info_display_short'),
        labelExtra: <HelperPopover localizedKey="univeral_message_popover" />,
        content: <UseResponses
          style={{ flex: 1 }}
          frame={props.frame}
          disabled={disabled}
          availableChannels={props.availableChannels}
          data={data}
          forSlot={props.forSlot}
          selectedParameters={props.selectedParameters}
          dataQueries={props.dataQueries}
          onChange={this.handleUpdate}
        />
      },
      ...!data.soft ? [
        {
          key: 'explicit-confirmation',
          label: localizedString('value_suggestion_single_prompts'),
          extra: data.singlePrompts && data.singlePrompts.filter(item => !item.toBeDeleted).length && <AddButton
            disabled={disabled || isStructAgent()}
            onClick={(e: any) => {
              this.singlePromptRef.current?.add(e);
            }} /> || '',
          content: <div className="single-wrapper" style={{ flex: 1 }}>
            <NewPromptList
              inModal
              ref={this.singlePromptRef}
              style={{ flex: 1 }}
              agentId={getAgentId()}
              frameId={props.frame.id}
              ownerId={data.id || ''}
              ownerType={PromptOwnerType.suggestion}
              promptType={PromptType.prompt}
              frame={props.frame}
              disableChange={disabled || isStructAgent()}
              isSingleLine={false}
              allowClearAll={true}
              data={data.singlePrompts}
              parameterMap={ParameterMapStore.all()}
              parameters={[...props.selectedParameters, ...props.dataQueries.map(dataQueryToParameter)]}
              bodyItTypeId={props.forSlot && props.forSlot.proto && props.forSlot.proto.id || props.frame.id}
              update={(values: PromptInfo[]) => {
                this.handleUpdate({ singlePrompts: values });
              }}
            />
            {/* {((forSlot && forSlot.multiValue)) &&
              <NiForm
                style={{ marginTop: 12, flex: 1 }}
                direction="vertical"
                items={[{
                  key: 'single-affirmatives',
                  label: <span style={{ marginLeft: 12 }}>{localizedString('value_rec_single_affirmatives')}</span>,
                  content: <TrainingPhraseComp
                    style={{ flex: 1 }}
                    className="trigger-expressions-wrap"
                    agentId={getAgentId()}
                    frameId={props.frame.id}
                    ownerId={props.data.id || ''}
                    ownerType={TrainingPhraseOwnerType.SUGGESTION}
                    phraseType={TrainingPhraseType.CONFIRM_YES}
                    disableChange={isStructAgent() || disabled}
                    isSingleLine={false}
                    allowClearAll={true}
                    data={data.singleAffirmatives || []}
                    parameterMap={ParameterMapStore.all()}
                    parameters={props.selectedParameters}
                    update={(values: TrainingPhraseConfig[]) => {
                      const nextData = cloneDeep(data);
                      nextData.singleAffirmatives = values;
                      this.handleUpdate(nextData);
                    }}
                  />
                }, {
                  key: 'single-negatives',
                  label: <span style={{ marginLeft: 12 }}>{localizedString('value_rec_single_negatives')}</span>,
                  content: <TrainingPhraseComp
                    style={{ flex: 1 }}
                    className="trigger-expressions-wrap"
                    agentId={getAgentId()}
                    frameId={props.frame.id}
                    ownerId={props.data.id || ''}
                    ownerType={TrainingPhraseOwnerType.SUGGESTION}
                    phraseType={TrainingPhraseType.CONFIRM_NO}
                    disableChange={isStructAgent() || disabled}
                    isSingleLine={false}
                    allowClearAll={true}
                    data={data.singleNegatives || []}
                    parameterMap={ParameterMapStore.all()}
                    parameters={props.selectedParameters}
                    update={(values: TrainingPhraseConfig[]) => {
                      const nextData = cloneDeep(data);
                      nextData.singleNegatives = values;
                      this.handleUpdate(nextData);
                    }}
                  />
                }]}
              />
            } */}

          </div>
        },
        {
          key: 'zero-prompts',
          label: localizedString('value_suggestion_zero_prompts'),
          extra: data.zeroPrompts && data.zeroPrompts.filter(item => !item.toBeDeleted).length && <AddButton
            disabled={disabled || isStructAgent()}
            onClick={(e: any) => {
              this.zeroPromptRef.current?.add(e);
            }} /> || '',
          content: <NewPromptList
            inModal
            ref={this.zeroPromptRef}
            style={{ flex: 1 }}
            agentId={getAgentId()}
            frameId={props.frame.id}
            ownerId={data.id || ''}
            ownerType={PromptOwnerType.suggestion}
            promptType={PromptType.zeroPrompt}
            frame={props.frame}
            disableChange={disabled || isStructAgent()}
            isSingleLine={false}
            allowClearAll={true}
            data={data.zeroPrompts}
            parameterMap={ParameterMapStore.all()}
            parameters={[...props.selectedParameters, ...props.dataQueries.map(dataQueryToParameter)]}
            update={(values: PromptInfo[]) => {
              this.handleUpdate({ zeroPrompts: values });
            }}
          />
        }
      ] : []
    ];

    return (
      <NiModal
        className="suggestion-modal"
        destroyOnClose
        open={props.visible}
        title={
          <div className="modal-title">
            <div>
              <FormattedMessage id="value_suggestion" />
              <HelperPopover localizedKey="suggestion_title_popover" />
            </div>
            <Space>
              {localizedString('value_rec_hard')}
              <Switch
                disabled={disabled || !!data.originKey}
                checked={!data.soft}
                onChange={(checked: boolean) => {
                  this.handleUpdate({ soft: !checked });
                }} />
            </Space>

          </div>
        }
        onCancel={this.handleCancel}
        width="80%"
        okText={(props.data.inheritedFromCompositeId && !disabled) &&
          <Popconfirm
            title={
              <span>{localizedString('value_suggestion_inherit_copy_popconfirm')}
                <HelperPopover localizedKey="value_suggestion_inherit_copy_popover" />
              </span>
            }
            okButtonProps={{
              disabled: isEqual(props.data, data)
            }}
            onConfirm={this.handleConfirm}
          >
            <a href="#">{localizedString('common_confirm')}</a>
          </Popconfirm> || undefined}
        onOk={() => {
          if (props.data.inheritedFromCompositeId ||
            disabled ||
            isEqual(props.data, data)) {
            return;
          }

          this.handleConfirm();
        }}
        okButtonProps={
          disabled ||
            isEqual(props.data, data) ? {
            type: 'ghost',
            disabled: true
          } : undefined}
      >
        <NiForm
          titleline
          direction="vertical"
          items={formItems}
          className="suggestion-modal-form" />
      </NiModal>
    );
  }

  initialData = (propsData: ValueSuggestionData) => {
    const data = cloneDeep(propsData);

    for (const channelTag of this.props.availableChannels) {
      let channelData: ActionChannel | undefined = (data.channels || [])
        .find((item: ActionChannel) =>
          item.tag === channelTag);

      if (!channelData) {
        channelData = {
          tag: channelTag as any,
          actions: [
            {
              type: 'list_action',
              itemSize: 5,
              delimiterField: '\\n',
              sourceType: SourceType.CODE_EXPRESSION,
              source: '',
              variable: [],
              parameters: [],
              header: '',
              footer: '',
              body: '',
              templateId: ''
            }
          ]
        };

        data.channels.push(channelData);
      }
    }
    return data;
  }

  onInit = () => {
    const props = this.props;
    const data = this.initialData(props.data);
    this.setState({
      data
    });
  }

  handleUpdate = (next: any) => {
    const state = this.state;
    this.setState({
      data: { ...state.data, ...next }
    });
  };

  dataValidation = () => {

    const state = this.state;
    const props = this.props;

    let valid = true;

    if (state.data.vrSourceType === ValueRecommendationSourceType.intent) {

      if (!state.data.sourceIntent || !state.data.sourceIntent.intent) {
        message.warning(localizedString('vr_source_intent_required'));

        valid = false;
      }
    } else {
      if (!state.data.source || !state.data.source.length) {
        message.warning(localizedString('value_suggestion_use_data_query_placeholder'));

        valid = false;
      }
    }

    return valid;
  }

  dirtyCheck = () => {
    return !isEqual(this.initialData(this.props.data), this.state.data);
  }

  handleCancel = () => {
    if (this.dirtyCheck()) {
      discardModal(() => {
        this.props.onClose();
      });
      return;
    }
    this.props.onClose();
  }

  handleConfirm = debounce(() => {
    const state = this.state;
    const props = this.props;

    if (!this.dataValidation()) {
      return;
    }

    const nextData = cloneDeep(state.data);

    props.onChange(nextData);
    props.onClose();
  }, 500);
}
